
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wideo",
      function () {
        return require("private-next-pages/wideo/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wideo"])
      });
    }
  